"use strict";

var _inherits = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _regeneratorRuntime = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _createForOfIteratorHelper = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var constants_1 = require("../constants");

var utils_1 = require("../utils");

var AccountModule = /*#__PURE__*/function () {
  function AccountModule(sdk) {
    _classCallCheck(this, AccountModule);

    this.sdk = sdk;
    this.state$ = new AccountModule.State();
  }

  _createClass(AccountModule, [{
    key: "initialize",
    value: function initialize() {
      var _this = this;

      var _this$sdk = this.sdk,
          platform = _this$sdk.clients.platform,
          _this$sdk$modules = _this$sdk.modules,
          notification = _this$sdk$modules.notification,
          accountAuthKey$ = _this$sdk$modules.accountAuthKey.state$,
          authKey = _this$sdk$modules.authKey.address;
      var subscriptions = null;
      this.state$.address$.subscribe(function (account) {
        if (subscriptions) {
          var _iterator = _createForOfIteratorHelper(subscriptions),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var subscription = _step.value;
              subscription.unsubscribe();
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          subscriptions = null;
        }

        if (platform && account) {
          subscriptions = [platform.subscribeAccountUpdated({
            account: account
          }).filter(function (value) {
            return !!value;
          }).subscribe(function (value) {
            _this.state$.next(value);

            notification.publish(constants_1.NotificationTypes.AccountUpdated, value);
          }), platform.subscribeAccountAuthKeyUpdated({
            account: account
          }).filter(function (value) {
            return !!value;
          }).subscribe(function (value) {
            if (value.address === authKey) {
              accountAuthKey$.next(value);
            }

            notification.publish(constants_1.NotificationTypes.AccountAuthKeyUpdated, value);
          }), platform.subscribeAccountEventProcessed({
            account: account
          }).filter(function (value) {
            return !!value;
          }).subscribe(function (value) {
            notification.publish(constants_1.NotificationTypes.AccountEventProcessed, value);
          }), platform.subscribeAccountDepositUpdated({
            account: account
          }).filter(function (value) {
            return !!value;
          }).subscribe(function (value) {
            notification.publish(constants_1.NotificationTypes.AccountDepositUpdated, value);
          }), platform.subscribeAccountPaymentChannelUpdated({
            account: account
          }).filter(function (value) {
            return !!value;
          }).subscribe(function (value) {
            notification.publish(constants_1.NotificationTypes.PaymentChannelUpdated, value);
          })];
        }
      });
    }
  }, {
    key: "createFromAuthKey",
    value: function createFromAuthKey() {
      var _this$sdk2 = this.sdk,
          accountRegistry = _this$sdk2.contracts.accountRegistry,
          authKey = _this$sdk2.modules.authKey.address;
      return this.createFromAddress(accountRegistry.computeAccountAddress(authKey));
    }
  }, {
    key: "createFromAddress",
    value: function createFromAddress(address) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this$sdk3, platform, accountRegistry, _this$sdk3$modules, accountAuthKey$, authKey, account, nonce, accountAuthKey;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$sdk3 = this.sdk, platform = _this$sdk3.clients.platform, accountRegistry = _this$sdk3.contracts.accountRegistry, _this$sdk3$modules = _this$sdk3.modules, accountAuthKey$ = _this$sdk3$modules.accountAuthKey.state$, authKey = _this$sdk3$modules.authKey.address;
                _context.next = 3;
                return platform.getAccount({
                  account: address
                });

              case 3:
                account = _context.sent;

                if (!account) {
                  _context.next = 13;
                  break;
                }

                _context.next = 7;
                return accountRegistry.getAccountNonce(address);

              case 7:
                nonce = _context.sent;
                this.state$.next(Object.assign({
                  nonce: nonce
                }, account));
                _context.next = 11;
                return platform.getAccountAuthKey({
                  authKey: authKey,
                  account: address
                });

              case 11:
                accountAuthKey = _context.sent;

                if (accountAuthKey) {
                  accountAuthKey$.next(accountAuthKey);
                }

              case 13:
                return _context.abrupt("return", this.state);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "reset",
    value: function reset() {
      var accountAuthKey$ = this.sdk.modules.accountAuthKey.state$;
      this.state$.reset();
      accountAuthKey$.reset();
    }
  }, {
    key: "verifyNonce",
    value: function verifyNonce() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var accountRegistry, nonce;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                accountRegistry = this.sdk.contracts.accountRegistry;
                _context2.next = 3;
                return accountRegistry.getAccountNonce(this.address);

              case 3:
                nonce = _context2.sent;
                this.state$.update({
                  nonce: nonce
                });
                return _context2.abrupt("return", nonce);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "state",
    get: function get() {
      return this.state$.getValue();
    }
  }, {
    key: "address",
    get: function get() {
      return this.state$.address$.getValue();
    }
  }]);

  return AccountModule;
}();

exports.AccountModule = AccountModule;

(function (AccountModule) {
  var State = /*#__PURE__*/function (_utils_1$StateSubject) {
    _inherits(State, _utils_1$StateSubject);

    var _super = _createSuper(State);

    function State() {
      var _this2;

      _classCallCheck(this, State);

      _this2 = _super.call(this, null, {
        prepare: function prepare(previousValue, nextValue) {
          return nextValue ? Object.assign(Object.assign({}, previousValue || {}), nextValue) : null;
        }
      });
      _this2.address$ = _this2.getSubSubject('address');
      return _this2;
    }

    return State;
  }(utils_1.StateSubject);

  AccountModule.State = State;
})(AccountModule = exports.AccountModule || (exports.AccountModule = {}));